import { render, staticRenderFns } from "./RainButton.vue?vue&type=template&id=05f25cc8&"
import script from "./RainButton.vue?vue&type=script&lang=js&"
export * from "./RainButton.vue?vue&type=script&lang=js&"
import style0 from "./RainButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports